<template>
  <div
    :class="[
      'card border-0 shadow-none rounded-1 mb-50 barcode-wrapper',
      { open: toggleBarcode.open },
    ]"
  >
    <div class="card-body p-xl-40">
      <h6 class="fs-18 mb-25">Smart Phone</h6>
      <div class="barcode-wrap mb-35">
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART PHONE</span>
          <img src="../../../assets/img/products/barcode-2.webp" alt="Image" />
        </div>
      </div>
      <h6 class="fs-18 mb-25">Smart Watch</h6>
      <div class="barcode-wrap">
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
        <div class="barcode-item text-center rounded-1">
          <span class="fs-12 text-title d-block mb-2">SMART WATCH</span>
          <img src="../../../assets/img/products/barcode-3.webp" alt="Image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "../../../utils/store";

export default defineComponent({
  name: "BarcodeWrapper",
  setup() {
    const toggleBarcode = stateStore;
    return {
      toggleBarcode,
    };
  },
});
</script>

<style lang="scss" scoped>
.barcode-wrapper {
  display: none;
  &.open {
    display: block;
  }
}
.barcode-wrap {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -7.5px;
  .barcode-item {
    border: 1px solid #e3e4e4;
    margin-bottom: 15px;
    margin: 0 7.5px 15px;
    width: calc(12.5% - 15px);
    padding: 16px 10px 17px;
  }
}

@media only screen and (max-width: 575px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(50% - 15px);
    }
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(33.33% - 15px);
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(25% - 15px);
    }
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(25% - 15px);
    }
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(20% - 15px);
    }
  }
}

@media only screen and (min-width: 1400px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(16.66% - 15px);
    }
  }
}

@media only screen and (min-width: 1600px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(14.28% - 15px);
    }
  }
}

@media only screen and (min-width: 1920px) {
  .barcode-wrap {
    .barcode-item {
      width: calc(12.5% - 15px);
    }
  }
}
</style>